export default () => {
    return {
        xAxis: {
            crosshair: {
                width: 1,
                dashStyle: "ShortDash",
            },
        },
    };
};
